import { useState } from 'react'
import { api } from 'api'
import { useInfiniteQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

const useFetchReportsList = () => {
  const [params, setParams] = useState({})

  let list = []
  let lastPage

  const query = useInfiniteQuery({
    queryKey: ['reportsList', params],
    queryFn: ({ pageParam }) => {
      return api.payments.fetchReports({
        ...params,
        page: pageParam,
        size: 20,
      })
    },
    initialPageParam: 0,
    getNextPageParam: ({ page }) => page + 1,
  })

  if (query.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузки отчетов',
      description: query.error?.message,
    })
  }

  const registryHistory = query.data?.pages

  if (registryHistory) {
    const content = query.data?.pages.reduce((acc, item) => [...acc, ...item.registryHistory], [])
    list = content?.length ? content : []
    lastPage = query.data?.pages[query.data?.pages.length - 1]
  }

  return {
    fetch: setParams,
    list,
    hasMore: lastPage?.page < lastPage?.totalPages - 1,
    lastPage,
    ...query,
  }
}

export default useFetchReportsList
